(function () {
    'use strict';

    function WZLastStepController(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        $ctrl.__config = __config;
        loadPage();
        $ctrl.goToSite = goToSite;
        $ctrl.getWebSiteUrl = getWebSiteUrl;
        $ctrl.getFeatureListUrl = getFeatureListUrl;
        $ctrl.getHelpUrl = getHelpUrl;


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();

            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        function goToSite() {

            if ($ctrl.wizardData.company && $ctrl.wizardData.company.keyUrl) {
                var websiteUrl = $ctrl.wizardData.company.keyUrl + '.' + __config.domain;
                window.open('http://' + websiteUrl, '_blank');
            }

        }

        function getWebSiteUrl() {
            if ($ctrl.wizardData.company && $ctrl.wizardData.company.keyUrl)
                return ($ctrl.wizardData.company.keyUrl + '.' + __config.domain);
        }

        function getFeatureListUrl() {
            if ($ctrl.__config.appMode == 'reserve') {
                if ($ctrl.__config.appName && $ctrl.__config.appName == "planovin") {
                    return "https://planovin.com/features";
                } else {
                    return "https://www.reserweb.ir/intro/featurelist.html";
                }

            }
        }

        function getHelpUrl() {
            if ($ctrl.__config.appMode == 'reserve') {
                if ($ctrl.__config.appName && $ctrl.__config.appName == "planovin") {
                    return "https://planovin.com/help";
                } else
                    return "https://help.reserweb.ir/";
            }
            if ($ctrl.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

    }

    var WZLastStep = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/last-step/wizard-form.last-step.html',
        controller: WZLastStepController,
        bindings:
            {
                wizardData: '='
            }

    };

    angular
        .module('tikonApp')
        .component('wzfLastStep', WZLastStep)

    WZLastStepController.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

